var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.replyLoading,
          expression: "replyLoading",
        },
      ],
      staticClass: "pc-reply-component",
    },
    [
      _c("div", { staticClass: "p-20" }, [
        _c("div", {
          ref: "textarea",
          staticClass: "dsf-bbs-detail-textarea",
          attrs: { contenteditable: "" },
          on: { input: _vm.textInput },
        }),
        _c("p", { staticClass: "maxlength" }, [
          _vm._v(
            " 当前已输入" +
              _vm._s(_vm.currentLength) +
              "个字符, 您还可以输入" +
              _vm._s(
                _vm.maxLength - _vm.currentLength >= 0
                  ? _vm.maxLength - _vm.currentLength
                  : 0
              ) +
              "个字符。 "
          ),
        ]),
        _c("div", { staticClass: "tool-box" }, [
          _c(
            "div",
            { staticClass: "left" },
            [
              _c(
                "el-popover",
                {
                  attrs: {
                    "append-to-body": false,
                    placement: "bottom-start",
                    "popper-class": "tool-popper",
                    trigger: "click",
                  },
                },
                [
                  _c("bbs-emoji", { on: { change: _vm.emojiChange } }),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.bts.indexOf("emoji") > -1,
                          expression: "bts.indexOf('emoji') > -1",
                        },
                      ],
                      staticClass: "tool-btn",
                      attrs: {
                        slot: "reference",
                        type: "text",
                        size: "medium",
                        icon: "iconfont icon-xiaolian",
                        title: "表情",
                      },
                      slot: "reference",
                    },
                    [_vm._v(" 表情 ")]
                  ),
                ],
                1
              ),
              _c(
                "el-upload",
                {
                  ref: "upload",
                  attrs: {
                    multiple: "",
                    accept: _vm.uploadFileExts,
                    headers: _vm.headersParam,
                    action: _vm.requestUrl,
                    "show-file-list": false,
                    "before-upload": _vm.beforeUpload,
                    "on-success": _vm.handleSuccess,
                    "on-error": _vm.handleError,
                    "on-exceed": _vm.handleExceed,
                    limit: parseInt(_vm.maxCount),
                  },
                },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.bts.indexOf("img") > -1,
                          expression: "bts.indexOf('img') > -1",
                        },
                      ],
                      staticClass: "tool-btn",
                      attrs: {
                        type: "text",
                        size: "medium",
                        icon: "iconfont icon-tupiantianjia",
                        title: "图片",
                      },
                    },
                    [_vm._v(" 图片 ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "right" },
            [
              _c(
                "el-button",
                {
                  staticClass: "comment-button",
                  attrs: {
                    disabled: _vm.btnDisabled,
                    size: "medium",
                    small: "",
                  },
                  on: { click: _vm.commentReply },
                },
                [_vm._v(_vm._s(_vm.btnText))]
              ),
            ],
            1
          ),
        ]),
        _c(
          "div",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.upfileLoading,
                expression: "upfileLoading",
              },
            ],
            staticClass: "file-imgs",
          },
          _vm._l(_vm.fileList, function (item, index) {
            return _c(
              "div",
              { key: item.id, staticClass: "item" },
              [
                _c("el-image", {
                  attrs: {
                    src: _vm.dsf.url.getWebPath(item.relativePath),
                    alt: item.originalFileName,
                    "preview-src-list": _vm.srcList,
                    fit: "contain",
                  },
                }),
                _c("i", {
                  staticClass: "del iconfont icon-icon2",
                  attrs: { title: "删除" },
                  on: {
                    click: function ($event) {
                      return _vm.handleRemove(index)
                    },
                  },
                }),
              ],
              1
            )
          }),
          0
        ),
      ]),
      _c("el-divider"),
      _c(
        "div",
        { ref: "content", staticClass: "replies-content p-20" },
        [
          _c("h3", { staticClass: "all-content" }, [
            _vm._v(" 全部讨论 "),
            _vm.detailContent
              ? _c("span", [_vm._v(_vm._s(_vm.detailContent.total))])
              : _vm._e(),
          ]),
          _c(
            "el-input",
            {
              staticClass: "search-wrap",
              attrs: {
                placeholder: "请输入关键字",
                clearable: "",
                maxlength: "50",
              },
              nativeOn: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.queryData()
                },
              },
              model: {
                value: _vm.queryParams.keywords,
                callback: function ($$v) {
                  _vm.$set(_vm.queryParams, "keywords", $$v)
                },
                expression: "queryParams.keywords",
              },
            },
            [
              _c(
                "el-button",
                {
                  attrs: { slot: "append" },
                  on: {
                    click: function ($event) {
                      return _vm.queryData()
                    },
                  },
                  slot: "append",
                },
                [_vm._v("搜索")]
              ),
            ],
            1
          ),
          _vm.detailContent && _vm.detailContent.comment.length
            ? [
                _vm._l(_vm.detailContent.comment, function (item, index) {
                  return _c(
                    "div",
                    { key: item.dsfaCommentId, staticClass: "replies-list" },
                    [
                      _c("div", { staticClass: "left" }, [
                        _c(
                          "div",
                          {
                            staticClass: "user-info",
                            on: {
                              click: function ($event) {
                                return _vm.userInfo(item)
                              },
                            },
                          },
                          [
                            _c(
                              "el-avatar",
                              {
                                attrs: {
                                  src:
                                    "/oua2/getUserPhoto?type=relativePath&userId=" +
                                    item.dsCreateUserId,
                                },
                                on: { error: _vm.errorHandler },
                              },
                              [
                                _c("i", {
                                  staticClass: "el-icon-picture-outline-round",
                                  staticStyle: {
                                    "font-size": "48px",
                                    "line-height": "48px",
                                  },
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]),
                      _c("div", { staticClass: "right" }, [
                        _c("div", { staticClass: "user-name" }, [
                          _c("div", { staticClass: "name" }, [
                            _vm._v(" " + _vm._s(item.dsCreateUserName) + " "),
                            item.belongName
                              ? _c("span", { staticClass: "belong" }, [
                                  _vm._v(_vm._s(item.belongName || "")),
                                ])
                              : _vm._e(),
                          ]),
                          _c("div", [
                            item.isOwner
                              ? _c(
                                  "span",
                                  {
                                    staticClass: "del",
                                    on: {
                                      click: function ($event) {
                                        return _vm.repliesDel(item, index)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _vm._e(),
                          ]),
                        ]),
                        item.plnr
                          ? _c("div", {
                              staticClass: "plnr",
                              domProps: { innerHTML: _vm._s(item.plnr) },
                            })
                          : _vm._e(),
                        item.img && item.img.length
                          ? _c(
                              "div",
                              { staticClass: "file-imgs" },
                              [
                                _vm._l(item.img, function (img, index) {
                                  return [
                                    index < _vm.listImagesLen
                                      ? _c(
                                          "div",
                                          { key: index, staticClass: "item" },
                                          [
                                            _c("el-image", {
                                              attrs: {
                                                src: img,
                                                fit: "contain",
                                                "preview-src-list":
                                                  item.previewImg,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ]
                                }),
                                item.img.length > _vm.listImagesLen
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "item",
                                        on: {
                                          click: function ($event) {
                                            _vm.listImagesLen = _vm.maxCount
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " +" +
                                            _vm._s(
                                              item.img.length -
                                                _vm.listImagesLen
                                            ) +
                                            "张 "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                        _c("div", { staticClass: "floor-page" }, [
                          _c("div", [_vm._v(_vm._s(item.showTime))]),
                          _c("div", { staticClass: "tools" }, [
                            _vm.openCollect
                              ? _c(
                                  "i",
                                  {
                                    staticClass: "iconfont",
                                    class: [
                                      item.btnNumMap &&
                                      item.btnNumMap.collect.isDo
                                        ? "icon-shoucang_shixin"
                                        : "icon-shoucang",
                                    ],
                                    attrs: { title: "收藏" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.btnDoHandle(item, "collect")
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          item.btnNumMap.collect.num || 0
                                        ) +
                                        " "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "i",
                              {
                                staticClass: "iconfont icon-pinglun",
                                attrs: { title: "回复" },
                                on: {
                                  click: function ($event) {
                                    return _vm.replyShow(item)
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(item.totalNum || 0))]
                            ),
                            _c(
                              "i",
                              {
                                staticClass: "iconfont",
                                class: [
                                  item.btnNumMap && item.btnNumMap.tags.isDo
                                    ? "icon-dianzan_kuai"
                                    : "icon-dianzan",
                                ],
                                attrs: { title: "点赞" },
                                on: {
                                  click: function ($event) {
                                    return _vm.btnDoHandle(item, "tags")
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(item.btnNumMap.tags.num || 0)
                                ),
                              ]
                            ),
                          ]),
                        ]),
                        _vm.replyId == item.dsfaCommentId
                          ? _c("div", { staticClass: "children-input" }, [
                              _c("div", {
                                ref: "child-plnr-" + item.dsfaCommentId,
                                refInFor: true,
                                staticClass: "dsf-bbs-detail-textarea",
                                attrs: {
                                  placeholder: "请输入你的回复",
                                  contenteditable: "",
                                },
                                on: {
                                  input: function ($event) {
                                    return _vm.textInput($event, item)
                                  },
                                },
                              }),
                              _c("p", { staticClass: "maxlength" }, [
                                _vm._v(
                                  " 当前已输入" +
                                    _vm._s(_vm.childLength) +
                                    "个字符, 您还可以输入" +
                                    _vm._s(
                                      _vm.maxLength - _vm.childLength >= 0
                                        ? _vm.maxLength - _vm.childLength
                                        : 0
                                    ) +
                                    "个字符。 "
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "children-emoji-btn" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex-emoji" },
                                    [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            "append-to-body": false,
                                            placement: "bottom-start",
                                            "popper-class": "tool-popper",
                                            trigger: "click",
                                          },
                                        },
                                        [
                                          _c("bbs-emoji", {
                                            on: {
                                              change: function ($event) {
                                                return _vm.emojiChange(
                                                  $event,
                                                  item
                                                )
                                              },
                                            },
                                          }),
                                          _c(
                                            "el-button",
                                            {
                                              staticClass: "tool-btn",
                                              attrs: {
                                                slot: "reference",
                                                type: "text",
                                                size: "medium",
                                                icon: "iconfont icon-xiaolian",
                                                title: "表情",
                                              },
                                              slot: "reference",
                                            },
                                            [_vm._v(" 表情 ")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      staticClass: "submit-btn",
                                      attrs: {
                                        disabled: _vm.childDisabled,
                                        size: "small",
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.commentReply(item)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.btnText))]
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _vm._e(),
                        item.totalNum > 0
                          ? _c("div", { staticClass: "child-list" }, [
                              _c(
                                "div",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: item.check,
                                      expression: "item.check",
                                    },
                                  ],
                                  staticClass: "expand-content",
                                },
                                [
                                  _vm._l(
                                    item.childList,
                                    function (child, cindex) {
                                      return [
                                        _c(
                                          "div",
                                          {
                                            key: child.dsfaCommentId,
                                            staticClass: "expand-item",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "user-info",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.userInfo(child)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "el-avatar",
                                                  {
                                                    attrs: {
                                                      src:
                                                        "/oua2/getUserPhoto?type=relativePath&userId=" +
                                                        child.dsCreateUserId,
                                                    },
                                                    on: {
                                                      error: _vm.errorHandler,
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-picture-outline-round",
                                                      staticStyle: {
                                                        "font-size": "48px",
                                                        "line-height": "48px",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "expand-plrn" },
                                              [
                                                _c(
                                                  "div",
                                                  { staticClass: "user-name" },
                                                  [
                                                    _c(
                                                      "div",
                                                      { staticClass: "name" },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              child.dsCreateUserName
                                                            ) +
                                                            " "
                                                        ),
                                                        child.belongName
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "belong",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    child.belongName ||
                                                                      ""
                                                                  )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _c("div", [
                                                      child.isOwner
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "del",
                                                              on: {
                                                                click: function (
                                                                  $event
                                                                ) {
                                                                  return _vm.repliesDel(
                                                                    child,
                                                                    index,
                                                                    cindex
                                                                  )
                                                                },
                                                              },
                                                            },
                                                            [_vm._v("删除")]
                                                          )
                                                        : _vm._e(),
                                                    ]),
                                                  ]
                                                ),
                                                child.dsCreateUserId !==
                                                child.bplrValue
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "plnr" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "m-user",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                child.dsCreateUserName
                                                              ) + " "
                                                            ),
                                                          ]
                                                        ),
                                                        _vm._v(" 回复  "),
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass: "user",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                child.bplrText
                                                              ) + "："
                                                            ),
                                                          ]
                                                        ),
                                                        _c("span", {
                                                          staticClass: "c-plnr",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              child.plnr
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    )
                                                  : _c(
                                                      "div",
                                                      { staticClass: "plnr" },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "m-user",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                child.dsCreateUserName
                                                              ) + "："
                                                            ),
                                                          ]
                                                        ),
                                                        _c("span", {
                                                          staticClass: "c-plnr",
                                                          domProps: {
                                                            innerHTML: _vm._s(
                                                              child.plnr
                                                            ),
                                                          },
                                                        }),
                                                      ]
                                                    ),
                                                _c(
                                                  "div",
                                                  { staticClass: "floor-page" },
                                                  [
                                                    _c("div", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("dateTime")(
                                                            child.dsCreateTime
                                                          )
                                                        )
                                                      ),
                                                    ]),
                                                    _c(
                                                      "div",
                                                      { staticClass: "tools" },
                                                      [
                                                        _c("i", {
                                                          staticClass:
                                                            "iconfont icon-pinglun",
                                                          attrs: {
                                                            title: "回复",
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.replyShow(
                                                                child
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "i",
                                                          {
                                                            staticClass:
                                                              "iconfont",
                                                            class: [
                                                              child.btnNumMap &&
                                                              child.btnNumMap
                                                                .tags.isDo
                                                                ? "icon-dianzan_kuai"
                                                                : "icon-dianzan",
                                                            ],
                                                            attrs: {
                                                              title: "点赞",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                return _vm.btnDoHandle(
                                                                  child,
                                                                  "tags"
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  child
                                                                    .btnNumMap
                                                                    .tags.num ||
                                                                    0
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                                _vm.replyId ==
                                                child.dsfaCommentId
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "children-input",
                                                      },
                                                      [
                                                        _c("div", {
                                                          ref:
                                                            "child-plnr-" +
                                                            child.dsfaCommentId,
                                                          refInFor: true,
                                                          staticClass:
                                                            "dsf-bbs-detail-textarea",
                                                          attrs: {
                                                            placeholder:
                                                              "请输入你的回复",
                                                            contenteditable: "",
                                                          },
                                                          on: {
                                                            input: function (
                                                              $event
                                                            ) {
                                                              return _vm.textInput(
                                                                $event,
                                                                child
                                                              )
                                                            },
                                                          },
                                                        }),
                                                        _c(
                                                          "p",
                                                          {
                                                            staticClass:
                                                              "maxlength",
                                                          },
                                                          [
                                                            _vm._v(
                                                              " 当前已输入" +
                                                                _vm._s(
                                                                  _vm.childLength
                                                                ) +
                                                                "个字符, 您还可以输入" +
                                                                _vm._s(
                                                                  _vm.maxLength -
                                                                    _vm.childLength >=
                                                                    0
                                                                    ? _vm.maxLength -
                                                                        _vm.childLength
                                                                    : 0
                                                                ) +
                                                                "个字符。 "
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "children-emoji-btn",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex-emoji",
                                                              },
                                                              [
                                                                _c(
                                                                  "el-popover",
                                                                  {
                                                                    attrs: {
                                                                      "append-to-body": false,
                                                                      placement:
                                                                        "bottom-start",
                                                                      "popper-class":
                                                                        "tool-popper",
                                                                      trigger:
                                                                        "click",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "bbs-emoji",
                                                                      {
                                                                        on: {
                                                                          change: function (
                                                                            $event
                                                                          ) {
                                                                            return _vm.emojiChange(
                                                                              $event,
                                                                              child
                                                                            )
                                                                          },
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "el-button",
                                                                      {
                                                                        staticClass:
                                                                          "tool-btn",
                                                                        attrs: {
                                                                          slot:
                                                                            "reference",
                                                                          type:
                                                                            "text",
                                                                          size:
                                                                            "medium",
                                                                          icon:
                                                                            "iconfont icon-xiaolian",
                                                                          title:
                                                                            "表情",
                                                                        },
                                                                        slot:
                                                                          "reference",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " 表情 "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _c(
                                                              "el-button",
                                                              {
                                                                staticClass:
                                                                  "submit-btn",
                                                                attrs: {
                                                                  disabled:
                                                                    _vm.childDisabled,
                                                                  size: "small",
                                                                },
                                                                on: {
                                                                  click: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.commentReply(
                                                                      child
                                                                    )
                                                                  },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.btnText
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    }
                                  ),
                                ],
                                2
                              ),
                              item.totalNum > 0
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "more",
                                      on: {
                                        click: function ($event) {
                                          return _vm.queryChildComment(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        { class: { "is-more": item.ismore } },
                                        [
                                          item.ismore
                                            ? [
                                                _vm._v(" 收起 "),
                                                _c("i", {
                                                  staticClass:
                                                    "iconfont icon-icon_up",
                                                }),
                                              ]
                                            : [
                                                _vm._v(
                                                  " 共" +
                                                    _vm._s(item.totalNum) +
                                                    "条回复，展开 "
                                                ),
                                                _c("i", {
                                                  staticClass:
                                                    "iconfont icon-icon_down",
                                                }),
                                              ],
                                        ],
                                        2
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ])
                          : _vm._e(),
                      ]),
                    ]
                  )
                }),
                _c("el-pagination", {
                  attrs: {
                    layout: "prev, pager, next",
                    "current-page": _vm.queryParams.fPageNo,
                    "page-size": _vm.queryParams.fPageSize,
                    total: _vm.detailContent.total,
                  },
                  on: {
                    "update:currentPage": function ($event) {
                      return _vm.$set(_vm.queryParams, "fPageNo", $event)
                    },
                    "update:current-page": function ($event) {
                      return _vm.$set(_vm.queryParams, "fPageNo", $event)
                    },
                    "current-change": _vm.queryData,
                  },
                }),
              ]
            : _c("div", { staticClass: "not-data" }, [_vm._v("暂无数据")]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }